/*
 Controller for loading/displaying the list of departments (and list of menus)
 */
angular.module('qkr').controller('outletController', ($scope, $routeSegment, $uibModal, outletService, appConfig) => {
    $scope.$routeSegment = $routeSegment;    // Used to know what we've selected
    $scope.outlets = [];
    $scope.loaded = false;

    $scope.init = function() {
        $scope.$routeSegment = $routeSegment;    // Used to know what we've selected

         // Set up the departments
        outletService.listOutlets().then((promise) => {
            $scope.outlets = promise;
            $scope.loaded = true;
        });
    };

    $scope.editOutlet = function(outlet) {
        $scope.showOutlet('edit', outlet);
    };

    $scope.showOutlet = function(action, outlet) {
        const modalInstance = $uibModal.open({
            template: require('../templates/outlet/storefront.html'),
            controller: 'OutletModalDialogController',
            windowClass: 'modal-huge',
            backdrop: 'static',
            resolve: {
                userAction() {
                    return action;
                },
                outlet() {
                    return outlet;
                }
            }
        });

        modalInstance.result.then((result) => {
            if (result === 'done') {
                $scope.onOutletChanged();
            }
        }, () => {

        });
    };
});



// WEBPACK FOOTER //
// ./src/controllers/outlet.controller.js